var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vyopta-dashboard-container" },
    _vm._l(_vm.computedPanels, function (panel, index) {
      return _c(
        "GridPanel",
        {
          key: index,
          staticClass: "panelContainer",
          class: ["width-" + panel.width, "height-" + panel.height],
          attrs: { panelHeader: panel.title },
        },
        [
          _c(_vm.getComponent(panel.component), {
            tag: "component",
            attrs: {
              panel: panel,
              "date-range": _vm.dateRange,
              filter: _vm.filterModel,
            },
            on: { clickCallback: _vm.handleFilterClick },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }